import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import ME from "../../assets/self.jpg";
import { BsAwardFill } from "react-icons/bs";
import { FiUsers, FiDroplet } from "react-icons/fi"; // Correct droplet icon from Feather Icons
import { FaProjectDiagram } from "react-icons/fa";
import "./about.css";
import { Link } from "react-router-dom";
import { urlFor } from "../../sanityClient";

const About = ({ about }) => {
  return (
    <section id="about" className="bg-alt p-12">
      <h2 className="fs-1">{about.sectionTitle}</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={urlFor(about.image.asset._ref).url()} alt="me" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            {about.boxes.map((box) => (
              <article className="about__card" key={box._key}>
                <img src={urlFor(box.image.asset._ref).url()} alt="" />
                <h5>{box.title}</h5>
                <small>{box.description}</small>
              </article>
            ))}
          </div>
          <p>{about.brief}</p>
          {/* <a
            href={`https://wa.me/${about.contactButton}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            تواصل معي
          </a> */}
          {/* <div className="extra-links">
              <Link to='/voice-acting'>
                <article className="service">
                  <div className="service__head">
                    <h3><FormattedMessage id="services.voiceActing" /></h3>
                
                  </div>
                </article>
              </Link>

              <Link to={'/content-creation'}>
                <article className="service">
                  <div className="service__head">
                    <h3><FormattedMessage id="services.contentCreation" /></h3>
                
                  </div>
                </article>
              </Link>
            </div> 
            */}
        </div>
      </div>
    </section>
  );
};

export default About;
